import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import RelativeRedirect from '../../../elements/RelativeRedirect';

/**
 * Used only by the preview app: opens the sidepanel map via a route change, then
 * redirects back to the parent route.
 */
export function EventMapRedirector() {
    const dispatch = useDispatch();

    // show spinner while visible
    useEffect(() => {
        dispatch(app.actions.ui.busy());
        return () => dispatch(app.actions.ui.free());
    }, []);

    //
    // show map
    useEffect(() => {
        dispatch(app.actions.ui.sidePanel.showEventMap(true));
    }, []);

    return <RelativeRedirect to=".." />;
}
